import React, { useContext } from 'react';
import Page from '../..';
import Table, { TableHeader } from '../../../Table';
import { setFilterColumn } from '../../../../store/utils';
import SVG from '../../../SVG';
import Form from '../../../Form';
import { ExportContext } from '../../../../provider/ExportProvider';
import { useAbility } from '../../../Hooks/useAbility';

const PageExportsCompanies = () => {
  const {
    companies,
    checkCompanyIds,
    allCompanyChecks,
    companyCheckAll,
    checkCompanyId,
    deleteCompanyLoadings,
    editCompany,
    searchFilter,
    setSearchFilter,
    getFilterField,
    getSortField,
    setSortField,
    getAutocompleteItems,
    setAutocompleteItems,
    setField,
    onLineClickHandler,
    setInvoice,
    TableControl,
    setModal,
  } = useContext(ExportContext)!.controllers.company;
  const { Can, ability } = useAbility();
  const canDeleteCompany = ability?.can('delete', 'Company');
  const canUpdateCompany = ability?.can('update', 'Company');
  const canUpdateOrDeleteCompany = canDeleteCompany || canUpdateCompany;
  const canUpdateAndDeleteCompany = canDeleteCompany && canUpdateCompany;

  const items = companies.map((company, index) => ({
    $isSelected: checkCompanyIds.includes(company.id),
    check: () => (
      <Form.Input.Checkbox
        checked={checkCompanyIds.includes(company.id)}
        onChange={() => checkCompanyId(company.id)}
      />
    ),
    ...company,
    ...(() =>
      canUpdateOrDeleteCompany
        ? {
            control: () => (
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: '10px',
                }}
              >
                <Can I="update" a="Company">
                  {() => (
                    <label
                      style={{
                        display: 'flex',
                        cursor: 'pointer',
                        alignItems: 'center',
                      }}
                    >
                      {true ? (
                        <SVG.Icon.Edit
                          onClick={() => {
                            editCompany(company);
                          }}
                          width={25}
                          height={25}
                        />
                      ) : (
                        <SVG.Icon.Loader width={25} height={25} />
                      )}
                    </label>
                  )}
                </Can>
                <Can I="delete" a="Company">
                  {() => (
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      {!deleteCompanyLoadings[index] ? (
                        <SVG.Icon.Trash
                          style={{ padding: '0 2.5px' }}
                          onClick={() => {
                            setModal('single.deleteCompanies', true);
                            setInvoice('selected.company', company.id);
                          }}
                          width={20}
                          height={20}
                        />
                      ) : (
                        <SVG.Icon.Loader width={25} height={25} />
                      )}
                    </label>
                  )}
                </Can>
              </label>
            ),
          }
        : {})(),
  }));

  const headers: TableHeader[] = [
    {
      text: (
        <Form.Input.Checkbox
          checked={allCompanyChecks}
          onChange={companyCheckAll}
        />
      ),
      value: 'check',
      width: 'auto',
    },
    {
      text: 'Nome',
      value: 'name',
      width: '1fr',
      sort: {
        value: getSortField('name'),
        onChange: setSortField('name'),
      },
      filter: {
        value: getFilterField('name'),
        onChange: setField('name'),
        items: getAutocompleteItems('name'),
        handleItems: () => setAutocompleteItems('name'),
        label: 'Nome da companhia',
      },
      onClear: () => {
        setSearchFilter(setFilterColumn('name', '', searchFilter));
        setInvoice(`autocompletes.companies.name.filter.value`, '');
      },
    },
    {
      text: 'Criado em',
      value: 'createdAt',
      width: '1fr',
      mask: ({ createdAt }) => new Date(createdAt).toLocaleString('pt-BR'),
      sort: {
        value: getSortField('createdAt'),
        onChange: setSortField('createdAt'),
      },
      interval: [
        {
          value: getFilterField('createdAt', 'GEQ'),
          onChange: setField('createdAt', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getFilterField('createdAt', 'LT'),
          onChange: setField('createdAt', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('createdAt', '', searchFilter, 'GEQ');
        filter = setFilterColumn('createdAt', '', filter, 'LT');
        setSearchFilter(filter);
      },
    },
    {
      text: 'Atualizado em',
      value: 'updatedAt',
      width: '0.7fr',
      mask: ({ updatedAt }) => new Date(updatedAt).toLocaleString('pt-BR'),
      sort: {
        value: getSortField('updatedAt'),
        onChange: setSortField('updatedAt'),
      },
      tooltip: {
        translateX: 1,
      },
      interval: [
        {
          value: getFilterField('updatedAt', 'GEQ'),
          onChange: setField('updatedAt', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getFilterField('updatedAt', 'LT'),
          onChange: setField('updatedAt', 'LT'),
          label: 'Data final',
        },
      ],
      onClear: () => {
        let filter = setFilterColumn('updatedAt', '', searchFilter, 'GEQ');
        filter = setFilterColumn('updatedAt', '', filter, 'LT');
        setSearchFilter(filter);
      },
    },
    ...(() =>
      canUpdateOrDeleteCompany
        ? [
            {
              text: '',
              value: 'control',
              width: canUpdateAndDeleteCompany ? '80px' : '40px',
              style: {
                margin: 'auto 10px auto auto',
              },
            },
          ]
        : [])(),
  ];

  return (
    <Page className="page-banner">
      <div
        style={{
          position: 'relative',
          transition: 'min-width 500ms, max-width 500ms',
          width: '100%',
          minHeight: 'calc(100vh - 130px)',
          maxHeight: 'calc(100vh - 130px)',
          margin: '0 1rem',
          background: '#DDDDDD',
          borderRadius: '5px',
          overflow: 'hidden',
        }}
      >
        <Table
          headers={headers}
          items={items}
          onLineClick={onLineClickHandler}
          size="small"
          containerStyle={{ height: 'calc(100vh - 210px)' }}
        >
          <TableControl />
        </Table>
      </div>
    </Page>
  );
};

export default PageExportsCompanies;
